import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { WidgetId } from '../../../../api/useWidgetsQuery';
import { TabSlug } from '../../../../types';
import { GroupSelection } from '../../../GroupSelection/GroupSelection';
import { PerformanceDetails } from '../../../PerformanceDetails/PerformanceDetails';

interface Props {
  title: string;
  id: WidgetId;
}

export const PerformanceDetailsCard = React.memo(({ title, id }: Props) => {
  return (
    <Box>
      <GroupSelection id={id} tabSlug={TabSlug.Performance} />

      <PerformanceDetails title={title} />
    </Box>
  );
});
